import React from 'react';
import { CaseDetailsTile, CaseDetailsTabs } from '../../logic/components';

const CaseDetailsRoute = () => {
  return (
    <>
      <div id="container1">
        <CaseDetailsTile />
      </div>

      <div id="container2">
        <CaseDetailsTabs />
      </div>
    </>
  );
};

export default React.memo(CaseDetailsRoute);
